import React from 'react';
import { Row, Col } from 'reactstrap';

const HistoryTab = () => {
  return (
    <Row>
      <Col md={12}>
        <div className="text-center p-4">
          <h5>History</h5>
          <p className="text-muted">Account history content will be implemented here.</p>
        </div>
      </Col>
    </Row>
  );
};

export default HistoryTab; 